export default "__VITE_ASSET__BR5t9xMx__"